import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { RegisterFormNaturalPersonComponent } from '../../main/register/register-form-natural-person/register-form-natural-person.component';
import { GetCandidate } from 'src/app/models/candidate/get-candidate';
import { GetAddress } from 'src/app/models/security/register-request';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { GetAdmin } from 'src/app/models/admin/get-admin';
import { UserRoleIds } from 'src/app/models/security/user-role-enum';

@Component({
  selector: 'app-my-account-admin',
  templateUrl: './my-account-admin.component.html',
  styleUrl: './my-account-admin.component.css',
  imports: [CommonModule, RegisterFormNaturalPersonComponent]
})
export class MyAccountAdminComponent {

  isLoading: boolean = false;
  isFound: boolean = false;
  admin: any = null;
  addresses: GetAddress[] = [];

  authService = inject(AuthService);
  alertService = inject(AlertService);
  userService = inject(UserService);

  typePerson: number = UserRoleIds.Admin;
  rolesId = UserRoleIds;

  constructor() { }

  ngOnInit(): void {
    this.getCandidateData();
  }

  getCandidateData(): void {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAdmin(userId).subscribe({
      next: (res) => {
        this.admin = res;
        if (res) {
          this.isFound = true;
          this.getAddresses();
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses() {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAddresses(userId).subscribe({
      next: (res) => {
        this.addresses = res;
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  savedCatcher(succeded: boolean) {
    if (succeded) {
      this.getCandidateData();
    }
  }
}
